export const WS_ON_CONNECT = 'WS_ON_CONNECT';
export const WS_ON_MESSAGE = 'WS_ON_MESSAGE';
export const WS_ON_OPEN = 'WS_ON_OPEN';
export const WS_ON_CLOSE = 'WS_ON_CLOSE';

export const WS_ON_ORDERS_MESSAGE = 'WS_ON_ORDERS_MESSAGE';
export const WS_ON_ORDERS_OPEN = 'WS_ON_ORDERS_OPEN';
export const WS_ON_ORDERS_CLOSE = 'WS_ON_ORDERS_CLOSE';
export const WS_ON_ORDERS_CONNECT = 'WS_ON_ORDERS_CONNECT';